import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { GeneralInformation } from "../template_offering_details_base";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useRoomsAnalytics } from "./rooms_analytics";
import { testimonials, usePartnerConfig } from "./rooms_partner_config";

const Theme = lazyWithRetry(() => import("./rooms_theme"));

const faqsEN = [
  {
    question: "What are your hours?",
    answer: "ROOMS workspaces are accessible 24 hours a day, 7 days a week.",
  },
  {
    question: "Is there somewhere I can park my car?",
    answer:
      "Parking is available in the building. Including scooter and bicycle parking room.",
  },
  {
    question: "What's included with my multi pass?",
    answer:
      "Our multi pass allows you to work on demand and within your time and budget, across our workspace. It includes access to everything: all services, community, and amenities.",
  },
  {
    question: "Is there somewhere I can make a call or have a meeting?",
    answer:
      "Yes, we do have phone booths to make a call and conference rooms you can easily book to host a meeting.",
  },
  {
    question: "Do you serve food and drinks?",
    answer:
      "We offer complimentary refreshments. Coffee, tea, water, soda and snacks are always available.",
  },
  {
    question: "When does my multi pass order expire?",
    answer:
      "Multiple-entrances valid for up to one year from the date of purchase and must be completed by the end of its validity.",
  },
];

const faqsHE = [
  {
    question: "מהם שעות פתיחת המתחם?",
    answer: "חללי העבודה של ROOMS נגישים 24 שעות ביממה, 7 ימים בשבוע. ",
  },
  {
    question: "האם אוכל להחנות את הרכב שלי?",
    answer: "חנייה בתשלום זמינה בבניין. ",
  },
  {
    question: "מה כלול ב-multi pass שלי?",
    answer:
      "מולטי פס / כרטיסייה מאפשרת לך לעבוד מכל מתחם ברשת ובחללים המשותפים. רכישת הכרטיסייה מאפשרת לך גישה לכל המתקנים, השירותים והחללים המשותפים במתחם.",
  },
  {
    question: "האם יש מקום שאני יכול להתקשר או לקיים פגישה?",
    answer:
      "כן, יש לנו תאי טלפון וחללים פרטיים לביצוע שיחות וחדרי ישיבות על בסיס מקום פנוי שתוכלו לארח את הקולגות שלכם.",
  },
  {
    question: "מגישים אוכל ושתייה?",
    answer: "אנו מציעים כיבוד חינם. קפה, תה, מים, סודה וחטיפים זמינים בכל זמן.",
  },
  {
    question: "לכמה זמן תקף כרטיסיית 10 הכניסות?",
    answer:
      "לאחר רכישת הכרטייסיה יהיה לך 10 כניסות לכלל מתחמי הרשת ויהיה ניתן לנצלם עד שנה מיום הרכישה. לאחר שנה תוקף הכרטייסיה פג.",
  },
];

const generalInfoEN: GeneralInformation = {
  title: `General information`,
  description: "",
  bulletPoints: [
    { text: "A changeable seat in the common area" },
    { text: "Meeting rooms credit points" },
    { text: "Access to premium site amenities and services" },
    {
      text: "Multiple-entrances valid for up to one year from the date of purchase and must be completed by the end of its validity.",
    },
  ],
};

const generalInfoHE: GeneralInformation = {
  title: `מידע כללי`,
  description: "",
  bulletPoints: [
    { text: "עמדה חמה 'הוטל דסק'." },
    { text: "חדרי ישיבות על בסיס מקום פנוי." },
    { text: "גישה לכל המתקנים, השירותים והחללים המשותפים במתחם." },
    {
      text: "10 כניסות יומית למתחמי הרשת, הכרטיסייה תקפה לשנה בלבד מיום הרכישה.",
    },
  ],
};

export function OfferingRoomsMultiPass() {
  useRoomsAnalytics();
  const { locale } = useI18n();
  const partnerConfig = usePartnerConfig();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          title: "Multi Pass",
          testimonials: testimonials,
          faqs: locale.baseLanguageTag === "he" ? faqsHE : faqsEN,
          generalInfo:
            locale.baseLanguageTag === "he" ? generalInfoHE : generalInfoEN,
        }}
      />
    </Fragment>
  );
}
